// extracted by mini-css-extract-plugin
export default {"loginFormBox":"login_loginFormBox__o30PL","signupTypo":"login_signupTypo__-6x-f","signupBox":"login_signupBox__+Hryf"};